import { createContext } from "react";

export const BookingForForm = createContext({});